import { FeatureName } from '@shipit/shared/feature-flags/util';
import { Directive, DirectiveBinding } from 'vue';
import { useFeatureAccessValidator } from '../composables/use-feature-access-validator';

const PermissionDirective: Directive<HTMLElement, FeatureName> = (element: HTMLElement, binding: DirectiveBinding<FeatureName>): void => {
    const { validateAccess } = useFeatureAccessValidator();
    const canAccess: boolean = validateAccess(binding.value);

    if (canAccess) {
        return;
    }

    element.remove();
};

export { PermissionDirective };
